/**
 * Strips a favorite medication down to only the fields needed for AI prompt generation.
 */
export function slimMedication(med: any) {
  const {
    id,
    name,
    quantity,
    quantity_unit,
    route,
    refills,
    comments,
    prn,
    dosage,
    dosage_unit,
    frequency,
    time,
    time_unit,
    dosing_instructions,
    drugbank_product,
  } = med;

  return {
    id,
    name,
    quantity,
    quantity_unit,
    route,
    refills,
    comments,
    prn,
    dosage,
    dosage_unit,
    frequency,
    time,
    time_unit,
    dosing_instructions,
    ...(drugbank_product && {
      drugbank_product: {
        prescribable_name: drugbank_product.prescribable_name,
        dosage_form: drugbank_product.dosage_form,
        route: drugbank_product.route,
        schedule: drugbank_product.schedule,
        ingredients: drugbank_product.ingredients?.map((ing: any) => ({
          name: ing.name,
          strength: ing.strength,
        })),
      },
    }),
  };
}
